import { render, staticRenderFns } from "./GroupConfiguratorProduct.vue?vue&type=template&id=412b543c&lang=pug"
import script from "./GroupConfiguratorProduct.vue?vue&type=script&lang=js"
export * from "./GroupConfiguratorProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports